/**
 * The same text for a picker's Enter (0110): trimmed and case-insensitive, so
 * "przyczepa jednoosiowa p-4 " is the catalog's "Przyczepa jednoosiowa P-4".
 */
export function sameText(text: string | null | undefined, term: string): boolean {
  return !!text && text.trim().toLocaleLowerCase('pl') === term.trim().toLocaleLowerCase('pl');
}

/**
 * A BOM item is what the planner typed when the term is its name or its part number —
 * the plant knows its parts by both.
 */
export function isExactBomItemMatch(item: { name: string, partNumber?: string | null }, term: string): boolean {
  return sameText(item.name, term) || sameText(item.partNumber, term);
}
